import React, { ForwardedRef } from 'react';

import cx from 'classnames';
import { WorkspaceMember } from 'clients/app/src/api/workspaces/getWorkspaceMembers';
import { Row } from 'react-table';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  row?: Row<WorkspaceMember>;
  header?: boolean;
  selectedRows: Array<Row<WorkspaceMember>>;
}
export const WorkspaceMemberTableRow = React.forwardRef(
  function WorkspaceMemberTableRow(
    { children, row, header, selectedRows }: Props,
    ref: ForwardedRef<HTMLDivElement>
  ) {
    const rowCx = cx(
      'w-full flex flex-row cursor-pointer select-none',
      header ? 'z-20 sticky top-0 bg-white' : '',
      row && (selectedRows ?? []).includes(row) ? 'bg-cyan-50' : ''
    );
    return (
      <div
        ref={ref}
        className={rowCx}
        style={{
          borderTop: header ? '1px solid rgb(232, 237, 240)' : 0,
          borderBottom: '1px solid rgb(232, 237, 240)',
          height: '54px',
        }}
      >
        {children}
      </div>
    );
  }
);
